<template>
<div class="chapter">
<div class="inner_page">
<div class="love">
<a href="https://earlybirdbooks.com/freebook?q=58e6f275e1799d0f58a9d95f" target="_blank"><img alt="loveit" src="Backed/img/loveitimage.jpg"/></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// loveit.vue?71a191c3